/**
 * @deprecated
 * @param {String} filename
 * @param {String} text
 * @see {@link { https://developer.mozilla.org/en-US/docs/Web/API/Event/initEvent }}
 */
// eslint-disable-next-line import/prefer-default-export
export function Download(filename, text) {
  const pom = document.createElement('a');
  pom.setAttribute('href', `data:text/plain;charset=utf-8,${encodeURIComponent(text)}`);
  pom.setAttribute('download', filename);

  if (document.createEvent) {
    const event = document.createEvent('MouseEvents');
    // TODO need to change the deprecated WEB API
    event.initEvent('click', true, true);
    pom.dispatchEvent(event);
  } else {
    pom.click();
  }
}
